import Toggle from './Toggle';
import './toggle.scss';

export default Toggle;
